import axios, { AxiosResponse } from 'axios';
import Swal from 'sweetalert2';
import NotificationService from '@/services/NotificationService';
const baseApiUrl: string = `${process.env.VUE_APP_BASE_API_URL_1}`;

const instance = axios.create({
  baseURL: `${baseApiUrl}/`,
});

instance.interceptors.response.use((res: AxiosResponse<any>) => res, (error: any) => {
  if (error.response === undefined) {
    NotificationService.error('Błąd połączenia z API', 'Aplikacja nie jest w stanie połączyć się z API systemu ITS, sprawdź stan swojego połączenia internetowego.');
    return Promise.reject(error);
  }
  if (error.response.status === 401) {
    return Swal.fire({
      title: 'Sesja wygasła',
      text: 'Serwer odrzucił połączenie, dane punktów nie; zostały zaktualizowane.',
      icon: 'error',
      showCancelButton: false,
      confirmButtonColor: '#00bcd4',
      confirmButtonText: 'Ok',
      showClass: {
        popup: '',
        backdrop: 'swal2-backdrop-show',
        icon: 'swal2-icon-show',
      },
      hideClass: {
        popup: '',
        backdrop: 'swal2-backdrop-hide',
        icon: 'swal2-icon-hide',
      },
    });
  }
  return Promise.reject(error);
});

export default instance;
